// S2 Phase 2.5 — 영업 "희망 spec" ↔ 재고 로봇 s양 매칭 평가 (제조 배정 보조).
//
// 모델은 이미 candidates() 쿼리에서 modelId 로 일치시키므로 여기선 색상/방향/
// 불감지 세 축만 평가한다. desired 의 각 축이 null/'' 이면 그 축은 "미지정"으로
// 보고 가점·감점 모두 없다(영업이 아직 인테리어 확정 전인 고객사). 모든 축이
// 미지정이면 tier='unspecified'.
//
// 매칭 규칙 (지정된 축만 평가):
//   - 지정 축이 모두 일치       → 'exact'
//   - 일부만 일치 (1개 이상 일치 + 1개 이상 불일치) → 'partial'
//   - 지정됐는데 전부 불일치     → 'mismatch'
//
// score = 일치한 지정-축의 가중 합. color/direction 은 2점, sensor 는 1점
// (색상·방향이 운영상 더 결정적이므로 가중을 둔다). UI 정렬 보조용.
// 축별 가중치 — 색상/방향은 운영상 더 결정적이므로 2점.
const AXIS_WEIGHT = { color: 2, direction: 2, sensor: 1 };
const AXIS_LABEL = { color: '색상', direction: '방향', sensor: '불감지' };
/** null / undefined / 공백-only 를 "미지정"으로 정규화. */
function normalize(v) {
    if (v === null || v === undefined)
        return null;
    const trimmed = v.trim();
    return trimmed.length === 0 ? null : trimmed;
}
export function matchRobotToDesiredSpec(desired, robot) {
    // [desiredValue, robotValue, axisKey] 3-tuple 로 정규화하여 일괄 평가.
    const axes = [
        [normalize(desired.color), normalize(robot.color), 'color'],
        [normalize(desired.direction), normalize(robot.variantValue), 'direction'],
        [normalize(desired.sensor), normalize(robot.sensorType), 'sensor'],
    ];
    let specifiedCount = 0;
    let matchedCount = 0;
    let score = 0;
    const mismatches = [];
    for (const [desiredValue, robotValue, axis] of axes) {
        if (desiredValue === null)
            continue; // 미지정 축은 평가 제외.
        specifiedCount += 1;
        // 대소문자 무시 비교 (White vs white). robotValue 가 null 이면 불일치.
        if (robotValue !== null && robotValue.toLowerCase() === desiredValue.toLowerCase()) {
            matchedCount += 1;
            score += AXIS_WEIGHT[axis];
        }
        else {
            mismatches.push(AXIS_LABEL[axis]);
        }
    }
    if (specifiedCount === 0) {
        return { tier: 'unspecified', score: 0, mismatches: [] };
    }
    let tier;
    if (matchedCount === specifiedCount) {
        tier = 'exact';
    }
    else if (matchedCount === 0) {
        tier = 'mismatch';
    }
    else {
        tier = 'partial';
    }
    return { tier, score, mismatches };
}
//# sourceMappingURL=spec-match.js.map